import { schema } from 'normalizr';
import apiResourceBuilder from '../../../../common/utils/apiResourceBuilder';
import entityActionCreator from '../../../../common/utils/entityActionCreator';

export const activitiesApi = apiResourceBuilder('emts/transactiondetails');

export const activitiesSchema = new schema.Entity(
  'activities',
  {},
  { idAttribute: 'eventKey' }
);
export default entityActionCreator({
  schema: activitiesSchema,
  api: activitiesApi,
});



// WEBPACK FOOTER //
// ./src/App/account/actions/activities/index.js